/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_W1Inputs */

const en_mk_cmp_notion_w1 = /** @type {(inputs: Mk_Cmp_Notion_W1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your main need is writing and storing knowledge, not tracking work.`)
};

const id_mk_cmp_notion_w1 = /** @type {(inputs: Mk_Cmp_Notion_W1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebutuhan utama Anda adalah menulis dan menyimpan pengetahuan, bukan melacak pekerjaan.`)
};

/**
* | output |
* | --- |
* | "Your main need is writing and storing knowledge, not tracking work." |
*
* @param {Mk_Cmp_Notion_W1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_w1 = /** @type {((inputs?: Mk_Cmp_Notion_W1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_W1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_w1(inputs)
	return en_mk_cmp_notion_w1(inputs)
});